import {
  all, call, put, take,
} from 'redux-saga/effects';
import firebase from '../common/firebase';

import * as adminActions from '../admin/actions';
import * as adminServices from '../admin/services';
import * as errorActions from '../errors/actions';
import * as userActions from '../user/actions';
import * as userServices from '../user/services';
import * as actions from './actions';
import * as services from './services';

import RedirectOrgService from './errors/RedirectOrgService';

import { OrganizationMemberRole } from '../common/constants/graphql';

function* fetchUser() {
  const response = yield call(userServices.fetchUser);

  yield put({ type: userActions.FETCH_USER_SUCCESS, payload: { info: response.data } });

  return response.data;
}

function* fetchAdminRelationships(payload) {
  const { sid } = payload;

  try {
    const [meResponse, orgResponse, subscribedResponse] = yield all([
      call(adminServices.fetchOrgServiceMe, { sid }),
      call(adminServices.fetchOrgServiceOrg, { sid }),
      call(adminServices.fetchOrgServiceSubscribeFeatures, { sid }),
    ]);

    const subscribedNewsletters = subscribedResponse.data?.find(({ code }) => code === 'newsletter');

    const admin = meResponse.data.organizationRole === OrganizationMemberRole.Admin || meResponse.data.organizationRole === OrganizationMemberRole.SuperAdmin;

    if (!admin || !subscribedNewsletters) {
      yield put({
        type: actions.SET_AUTH_FAILURE,
        payload: { error: new RedirectOrgService() },
      });
    }

    const adminRelationships = { org: orgResponse.data, me: meResponse.data, subscribedFeatures: subscribedResponse.data };
    yield put(adminActions.fetchAdminRelationshipsSuccess({ adminRelationships }));

    return adminRelationships;
  } catch (e) {
    yield put({
      type: actions.SET_AUTH_FAILURE,
      payload: { error: new RedirectOrgService() },
    });
    return {};
  }
}

function* signInFirebase(accessToken, schoolIds) {
  const response = yield call(services.createFirebaseToken, accessToken, schoolIds);

  const customToken = response.data.custom_token;
  yield call(firebase.auth.signInWithCustomToken, customToken);
}

export function* setAuth() {
  while (true) {
    try {
      const action = yield take(actions.SET_AUTH_REQUEST);

      const { accessToken, schoolId } = action.payload;

      if (accessToken) {
        window.sessionStorage.setItem('access_token', accessToken);

        const [user, adminRelationships] = yield all([
          call(fetchUser),
          call(fetchAdminRelationships, { sid: schoolId }),
        ]);

        if (user.role === 'teacher') {
          if (adminRelationships.org.id) {
            yield call(signInFirebase, accessToken, [adminRelationships.org.id]);

            const firebaseClaims = yield call(firebase.auth.getClaims);
            yield put(actions.setAccessibleSchoolIds({ accessibleSchoolIds: [firebaseClaims.school_ids] }));
          }
        } else {
          yield put({
            type: actions.SET_AUTH_FAILURE,
            payload: { error: new RedirectOrgService() },
          });
          break;
        }
        yield put(actions.setAuthSuccess({ accessToken }));
      }
    } catch (error) {
      yield put({
        type: actions.SET_AUTH_FAILURE,
        payload: { error: new RedirectOrgService() },
      });

      yield put(errorActions.errorOccured({ error }));
    }
  }
}

export function* signOut() {
  while (true) {
    try {
      yield take(actions.SIGN_OUT_REQUEST);

      window.sessionStorage.removeItem('access_token');

      const prodOrgServiceURL = 'https://organization.classting.com';
      const stagOrgServiceURL = 'https://organization.classting.net';
      const orgServiceURL = process.env.REACT_APP_STAGE === 'stag' ? stagOrgServiceURL : prodOrgServiceURL;

      window.location.replace(`${orgServiceURL}/api/auth/federated-logout`);
    } catch (error) {
      yield put(actions.signOutFailure({ error }));

      yield put(errorActions.errorOccured({ error }));
    }
  }
}
